import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { UserIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { routeEndpoints } from "../../../../routes/routeEndpoints";

interface AccountBenefitsProps {
  title: string;
  subtitle: string;
  benefits: string[];
}

export default function AccountBenefits({
  title,
  subtitle,
  benefits,
}: AccountBenefitsProps) {
  const navigate = useNavigate();

  return (
    <div className="mt-4 flex flex-col items-center auth-nav-toggle">
      <div className="text-center mb-6">
        <h3 className="md:text-xl text-sm font-medium text-slate-800 mb-1">
          {title}
        </h3>
        <p className="md:text-xl text-xs text-slate-500">{subtitle}</p>
      </div>
      <div className="bg-[#FFF9F0] w-full rounded-xl md:p-5 p-4 mb-6">
        <ul className="space-y-3">
          {benefits.map((benefit, index) => (
            <li
              key={index}
              className="flex items-center text-sm md:text-xl text-slate-700"
            >
              <CheckCircleIcon className="size-6 mr-3 shrink-0 text-[#F9814D]" />
              {benefit}
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={() => navigate(routeEndpoints.signup)}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center cursor-pointer transition-colors"
      >
        <UserIcon className="w-5 h-5 mr-2" />
        Create account
      </button>

      <div className="mt-5 text-center md:text-base text-sm text-slate-500">
        Already have an account?{" "}
        <button
          type="button"
          onClick={() => navigate(routeEndpoints.login)}
          className="text-[#0A58CA] font-medium hover:underline cursor-pointer"
        >
          Login
        </button>
      </div>
    </div>
  );
}
